<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="375" height="676" viewBox="0 0 375 676" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="187" cy="338" r="337.5" stroke="#272D37" />
</svg>
